import { configConstants as cats } from "../../../constants/configs";

const initialState = { loading: true, list: [], categorie: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case cats.GET_CATEGORIES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case cats.GET_CATEGORIE:
      return {
        ...state,
        loading: false,
        categorie: payload,
      };
    default:
      return state;
  }
}
